import Vue from 'vue';
import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';

Highcharts.setOptions({
    credits: {
        enabled: false,
    },
    title: {
        style: {
            display: 'none',
        },
    },
    plotOptions: {
        column: {
            maxPointWidth: 50
        }
    }
});

Vue.use(HighchartsVue);

export default {};